import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'NumericFilter'})
export class NumericFilter implements PipeTransform {
  transform(value:any,shosubits:any): string {
    if (value === undefined || value === null || value === '') {
      return '';
    } else {      
      let isMinus: boolean = false;
      let valueStr: string = ('' + value).trim();
      if (valueStr.startsWith('-')) {
        valueStr = valueStr.substr(1);
        isMinus = true;
      }
      let shosu = '';
      let seisu = '';
      let retDigit = '';
      let aDigits = valueStr.split('.');
      if (aDigits.length == 1) {
        seisu = aDigits[0];
      } else {
        seisu = aDigits[0];
        shosu = aDigits[1];
      }
      for (let i = 0; i < Math.floor(seisu.length / 3); i++) {        
        retDigit = ',' + seisu.substr(seisu.length - 3 * i - 3, 3) + retDigit;
      }
      if (seisu.length % 3 > 0) {
        retDigit = seisu.substr(0, seisu.length % 3) + retDigit;
      } else {
        retDigit = retDigit.substr(1);
      }      
      valueStr = (shosu == '' || ('' + shosubits) =='0') ? retDigit : retDigit + '.' + shosu;     
      return isMinus ? '-' + valueStr : valueStr;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/pipes/numeric.pipe.ts